import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SectorType } from '../interfaces/sector';
import { ServerUrlService } from './server-url.service';

@Injectable({
    providedIn: 'root'
})
export class SetoresService {
    
    private headers: any
    private setores: SectorType[] = []

    constructor(private serverUrl: ServerUrlService, private http: HttpClient) {
        this.headers = {
            headers: {
                'Content-Type': 'application/json'
            }
        }
    }

    public getSetores(): Observable<any> {
        return this.http.get(`${this.serverUrl.getUrl()}/setores`,
            this.headers
        )
    }

    /**
     * Devolve o Observable em vez de assinar aqui (#13788): o subscribe vazio dentro do
     * service deixava qualquer erro do backend invisível na tela — quem chama decide
     * o que fazer com sucesso e erro.
     */
    public insertSetor(formData: SectorType): Observable<any> {
        return this.http.post(
            `${this.serverUrl.getUrl()}/setores`,
            JSON.stringify(formData),
            this.headers
        )
    }

    public updateSetor(formData: SectorType): Observable<any> {
        return this.http.put(
            `${this.serverUrl.getUrl()}/setores`,
            JSON.stringify(formData),
            this.headers
        )
    }

    deleteSetor(id: number): void {
        this.http.delete(
            `${this.serverUrl.getUrl()}/setores/${id}`, this.headers
        ).subscribe(
            (result) => {
                console.log('Delete', result)
            }
        )
    }

    hasSetores() {
        const totemId = sessionStorage.getItem('totemPainel')
        return this.http.get(`${this.serverUrl.getUrl()}/setores/botao/${totemId}`,
            this.headers
        )
    }

    getSetoresByTotem(totemId: number | string): Observable<any> {
        return this.http.get(`${this.serverUrl.getUrl()}/totem/setores/${totemId}`)
    }

    insertSetorInTotem(totemId: number | string, setorId: number | string): Observable<any> {
        return this.http.post(`${this.serverUrl.getUrl()}/totem/setores`, {
            idtotem: totemId,
            idsetor: setorId
        })
    }

    deleteSetorFromTotem(totemId: number | string, setorId: number | string): Observable<any> {
        return this.http.delete(`${this.serverUrl.getUrl()}/totem/setores/${totemId}/${setorId}`)
    }
}
